export const SET_USER_NAVIGATION = "set";

const initialState = {
    type: SET_USER_NAVIGATION,
    sidebarShow: 'responsive'
};

const NavigationReducer = function (state = initialState, action) {
    // console.log(action, state)
    switch (action.type) {
        case SET_USER_NAVIGATION: {
            return {sidebarShow: action.sidebarShow};
        }
        default: {
            // console.log(action)
            return state;
        }
    }
};

export default NavigationReducer;
